import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import DashboardCards from "../components/DashboardCards/DashboardCards";

import "../styles/Dashboard.css";
import LineChartComponent from "../components/LineGraphComponent/LineChartComponent";
import BarChartComponent from "../components/GraphComponent/BarChartComponent";
import TableComponent from "../components/TableComponent/TableComponent";

import TitleComponent from "../components/TitleComponent/TitleComponent";
import { ICONS } from "../constants/constants";
import { useSelector, useDispatch } from "react-redux";
import { handleUpdateUser } from "../store/actions/userActions";
import { handleDeleteSupplier } from "../store/actions/suppliersActions"; // Import the action
import { handleGetCompanyData } from "../store/actions/adminActions";
// getAdminIdFromToken removed (unused)
// import EditFarmerModal from "../components/Modals/EditFarmerModal";

import { Link } from "react-router-dom";
import { handleGetTenantData, handleGetTenantAdminsData, handleGetTenantSuppliersData } from "../store/actions/tenantsActions";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Loader from "../assets/images/loader.gif";

const Suppliers = () => {
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.user);
  const { tenantSuppliersData, tenantAdminsData, isLoading } = useSelector((state) => state.tenants);

  const adminId = user?.id;
  const companyId = user?.company?.id;
  const role = user?.role;
  // const { role } = getAdminIdFromToken();

  const tenantId = role === "superadmin" ? user?.tenant?.id : null; // Save superAdminId if role is superadmin

  useEffect(() => {
    if (role === "superadmin" && tenantId) {
      // Fetch tenant data for superadmin
      dispatch(handleGetTenantData(tenantId));
    
            dispatch(handleGetTenantAdminsData(tenantId));
                  dispatch(handleGetTenantSuppliersData(tenantId));
                
    } else if ((role === "admin" || role === "manager") && companyId) {
      // Fetch company data for admin users
      dispatch(handleGetCompanyData(companyId));
    }
  }, [dispatch, adminId, tenantId, role, companyId]);

  // const usersList = tenantData?.data?.tenant?.users;

 
  const superAdminSuppliers = tenantSuppliersData?.data?.suppliers;
 


  // Access the adminData from the Redux store
  const { adminList } = useSelector((state) => state.admin);

  //const suppliersList = adminData?.admin?.adminUsers?.filter(user => user.role === "supplier");
  // Support both admin/getadmindata and company/:id shapes
  const companySource = adminList?.admin || adminList?.data?.company;
  const companyName = companySource?.name || companySource?.company?.name;

  const suppliersList = superAdminSuppliers;

  const deleteSupplier = (supplierId) => {
    dispatch(handleDeleteSupplier(supplierId));
  };
  const calculateTotalShiriahBudget = (suppliersList) => {
    if (!suppliersList || suppliersList.length === 0) {
      return "0.00"; // Return as formatted string
    }

    const total = suppliersList.reduce((sum, supplier) => {
      const supplierTotal = supplier.supplierShiriahBudgets?.reduce(
        (budgetSum, budget) => budgetSum + (budget.total_budget || 0),
        0
      );
      return sum + supplierTotal;
    }, 0);

    return parseFloat(total).toFixed(2); // Ensures proper formatting
  };

  // Example Usage
  const totalShiriahBudget = calculateTotalShiriahBudget(suppliersList);

  // Suppliers list is obtained from company or tenant data; no separate fetch here

  // Define a function to handle account status update to "Approved"
  const approveSupplier = async (supplierId) => {
    const formData = { account_status: "Approved" };
    await handleUpdateUser(supplierId, formData, dispatch);
  };

  // Define data for BarChartComponent
  const barChartData = {
    labels: [
      "Supplier 1",
      "Supplier 2",
      "Supplier 3",
      "Supplier 4",
      "Supplier 5",
      "Supplier 6",
      "Supplier 7",
    ],
    datasets: [
      {
        label: "Pofit Shares",
        data: [12, 19, 3, 5, 2, 3, 7],
      },
      {
        label: "Advances",
        data: [10, 14, 5, 2, 20, 30, 45],
      },
      {
        label: "Dues",
        data: [10, 14, 5, 2, 20, 30, 45],
      },
    ],
  };

  // Define data for LineChartComponent
  const lineChartData = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep"],
    datasets: [
      {
        label: "Rice",
        data: [30, 45, 28, 50, 42, 56, 40, 55, 30],
        borderColor: "rgba(75, 192, 192, 1)",
        backgroundColor: "rgba(75, 192, 192, 0.2)",
        tension: 0.4,
      },
      {
        label: "White",
        data: [20, 35, 25, 45, 35, 50, 38, 48, 25],
        borderColor: "rgba(255, 159, 64, 1)",
        backgroundColor: "rgba(255, 159, 64, 0.2)",
        tension: 0.4,
      },
      {
        label: "Corn",
        data: [25, 40, 22, 48, 38, 52, 33, 50, 28],
        borderColor: "rgba(153, 102, 255, 1)",
        backgroundColor: "rgba(153, 102, 255, 0.2)",
        tension: 0.4,
      },
    ],
  };
  // const [showEditModal, setShowEditModal] = useState(false); // State to control edit modal visibility
  // // Handle edit icon click to show edit modal
  // const handleEditClick = () => {
  //   setShowEditModal(true); // Show the edit modal
  // };

  // PDF Downloader
  const handleDownloadPDF = (supplier) => {
    const doc = new jsPDF();

    // Title
    doc.setFontSize(18);
    doc.text("Supplier Details", 14, 20);

    // Farmer Data
    // const farmArea = supplier.farmDetails?.reduce(
    //   (sum, farm) => sum + (parseFloat(farm.farm_area) || 0),
    //   0
    // );

    const tableColumn = ["Field", "Details"];
    const tableRows = [
      ["ID", supplier?.id],
      ["Name", supplier?.name],
      // ["Email", supplier?.email],
      ["Phone", supplier?.mobile_number || "N/A"],
      ["CNIC", supplier?.cnic || "N/A"],
      // ["Farm Area", farmArea ? `${farmArea} acres` : "N/A"],
      ["Status", supplier?.account_status || "Pending"],
    ];

    // AutoTable for formatting
    doc.autoTable({
      startY: 30,
      head: [tableColumn],
      body: tableRows,
      theme: "grid",
      headStyles: {
        fillColor: [0, 128, 0], // Green header background
        textColor: [255, 255, 255], // White text color
        fontStyle: "bold",
      },
    });

    // Save PDF
    doc.save(`Supplier_${supplier?.id}.pdf`);
  };

  const tableTitle = "Suppliers";

  const columns = ["Name", "Company", role !== "manager" ? "Mobile" : "", role !== "manager" ? "CNIC" : "", "Status", "Actions"];

  // const data = suppliersList?.data?.suppliers?.map((supplier) => ({
  // If manager, show only Approved suppliers
  const visibleSuppliersList =
    role === "manager" 
      ? ( (companySource?.adminUsers || companySource?.suppliers || []).filter((u) => u.role === "supplier" && u.account_status === "Approved") )
      : role === "admin"
    ? (companySource?.adminUsers || companySource?.suppliers || [])
        .filter((u) => u.role === "supplier") // admin condition
    : suppliersList;
  console.log('visibleSuppliersList', visibleSuppliersList);
  const data = visibleSuppliersList?.map((supplier) => ({
    id: supplier?._id,
    Name: supplier?.name,
    Company: supplier?.company?.name || companyName || "N/A", // Use company name if available
    ...(role !== "manager" ? { Mobile: supplier?.mobile_number || "N/A" } : {}), // Replace 'N/A' with default if 'mobile' is not available
    ...(role !== "manager" ? { CNIC: supplier?.cnic } : {}),
    Status: supplier?.account_status,
    Actions:
      role === "manager" ? (
        <>
          <Link to={`/supplier/${supplier.id}`} state={{ supplier }} rel="noopener noreferrer">
            <img src={ICONS.viewIcon} alt="View" className="tick-icon" />
          </Link>
          <img src={ICONS.downloadIcon} alt="Download" className="cross-icon" style={{ opacity: 0.5, pointerEvents: "none" }} />
        </>
      ) : supplier?.account_status === "Approved" ? (
        <>
          <Link to={`/supplier/${supplier.id}`} state={{ supplier }} rel="noopener noreferrer">
            <img src={ICONS.viewIcon} alt="View" className="tick-icon" />
          </Link>
          <img src={ICONS.downloadIcon} alt="Download" className="cross-icon" onClick={() => handleDownloadPDF(supplier)} />
        </>
      ) : (
        <>
          <Link to={`/supplier/${supplier.id}`} state={{ supplier }} rel="noopener noreferrer">
            <img src={ICONS.viewIcon} alt="View" className="tick-icon" />
          </Link>
        </>
      ),
  }));

  // Pass dynamically if these features should be shown
  const showSearchBar = true; // Change to false to hide search bar
  const searchplaceholder = "Enter Supplier’s Name, Company";
  const showFilter = true; // Change to false to hide filter
  const showTabs = true; // Change to false to hide tabs (Approved/Not Approved)
  const showColors = false;
  const getCountByRole = (role) => {
    const users = companySource?.adminUsers || companySource?.suppliers || user?.adminUsers || [];
    return users.filter((u) => u.role === role).length || 0;
  };

  const getCountByApprovalStatus = (role, status) => {
    const users = companySource?.adminUsers || companySource?.suppliers || user?.adminUsers || [];
    return users.filter((u) => u.role === role && u.account_status === status).length || 0;
  };

  const getCounts = () => {
    const totalSuppliers = suppliersList?.length;
    const activeSuppliers = suppliersList?.filter(
      (supplier) => supplier.account_status === "Approved"
    ).length;

    const deactivatedSuppliers =
      suppliersList?.filter(
        (supplier) => supplier.account_status !== "Approved"
      ).length || 0;
    return {
      totalSuppliers,
      activeSuppliers,
      deactivatedSuppliers,
    };
  };

  // Dynamic values for dashboard cards
  const cardData = [
    ...(user?.role !== "manager"
      ? [
        {
          title: "Amount Earned",
          value: `${totalShiriahBudget} PKR`, // Assuming you can calculate this dynamically from your data
          colorKey: "budget",
          imageKey: "budgetIcon",
        },
        ]
      : []),
    
    {
    title: "Total Suppliers",
    value: `${
      (role === "admin" || role === "manager")
        ? getCountByRole("supplier")
        : getCounts().totalSuppliers
    }`,
      colorKey: "dues",
      imageKey: "supplierIcon",
    },
    {
      title: "Approved Suppliers",
      value: `${
        (role === "admin" || role === "manager")
          ? getCountByApprovalStatus("supplier", "Approved")
          : getCounts().activeSuppliers
      }`,
      colorKey: "supplier",
      imageKey: "activesupplierIcon",
    },
    {
      title: "Not Approved Suppliers",
      value: `${
        (role === "admin" || role === "manager")
          ? getCountByApprovalStatus("supplier", "NotApproved")
          : getCounts().deactivatedSuppliers
      }`,
      colorKey: "consultant",
      imageKey: "inactivesupplierIcon",
    },
    
  ];
  if (isLoading) {
    return (
      <div className="loaderOverlay">
        <img src={Loader} alt="Loader" />
      </div>
    );
  }
  return (
    <Container>
      <Row>
        <Col lg={12} className="component-container mb-2">
          <TitleComponent title="Dashboard" />
          <DashboardCards cardData={cardData} />
        </Col>
      </Row>
      {user?.role !== "manager" && (
        <Row className="d-flex justify-content-between two-columns">
          <Col md={5} className="component-container mb-2">
            <TitleComponent title="Supplier Finance" />

            <BarChartComponent data={barChartData} />
          </Col>
          <Col md={5} className="component-container right mb-2 ms-1">
            <TitleComponent title="Earnings via Top Products" />

            <LineChartComponent data={lineChartData} />
          </Col>
        </Row>
      )}
      <Row>
        <Col lg={12} className="component-container mb-2">
          <TableComponent
            columns={columns}
            data={data}
            title={tableTitle}
            showSearchBar={showSearchBar}
            searchplaceholder={searchplaceholder}
            showFilter={showFilter}
            showTabs={showTabs && user?.role !== "manager"}
            showColors={showColors}
          />
        </Col>
      </Row>
      {/* <EditFarmerModal
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
        user={user}
        userType={user?.userdatarole}
      /> */}
    </Container>
  );
};

export default Suppliers;
